import { useEffect, useState } from "react"
import axios from "axios"
import "./flyerDashboard.css"
import lbnlogo from "../Images/lbnlogo.png"

export default function FlyerAdminDashboard() {
  const [visitors, setVisitors] = useState([])
  const [selected, setSelected] = useState(null)
  const [visits, setVisits] = useState([])

  useEffect(() => {
    fetchVisitors()
  }, [])

  useEffect(()=>{

const admin = localStorage.getItem("flyerAdmin")

if(!admin){
window.location="/flyer-admin"
}

},[])

  const fetchVisitors = async () => {
    const res = await axios.get(
      "https://api.lbnhyderabad.com/signup/api/memberflyer/admin/visitors"
    )
    if (res.data.success) {
      setVisitors(res.data.visitors)
    }
  }

  const openVisitor = async (mobile) => {
    setSelected(mobile)
    const res = await axios.get(
      `https://api.lbnhyderabad.com/signup/api/memberflyer/admin/visitor/${mobile}`
    )
    if (res.data.success) {
      setVisits(res.data.visits)
    }
  }

  const logout = ()=>{
localStorage.removeItem("flyerAdmin")
window.location="/flyer-admin"
}



  return (
    <div className="flyer-admin-dashboardContainer">
      {/* HEADER */}
      <header className="flyer-admin-dashboardHeader">
        <img src={lbnlogo} className="flyer-admin-dashboardLogo" alt="Logo" />
        <h2>Flyer Admin Dashboard</h2>
        <button onClick={logout} className="logoutBtn">
Logout
</button>
      </header>

      {/* TABLE */}
      <div className="flyer-admin-tableContainer">
        <table className="flyer-admin-table">
          <thead>
            <tr>
              <th className="flyer-admin-th">Name</th>
              <th className="flyer-admin-th">Mobile</th>
              <th className="flyer-admin-th">Total Visits</th>
              <th className="flyer-admin-th">View</th>
            </tr>
          </thead>
          <tbody>
            {visitors.map((v, i) => (
              <tr key={i}>
                <td className="flyer-admin-td">{v.visitor_name}</td>
                <td className="flyer-admin-td">{v.visitor_mobile}</td>
                <td className="flyer-admin-td flyer-admin-count">{v.visit_count}</td>
                <td className="flyer-admin-td">
                  <button
                    className="flyer-admin-viewBtn"
                    onClick={() => openVisitor(v.visitor_mobile)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {selected && (
        <div className="flyer-admin-modalOverlay">
          <div className="flyer-admin-modalBox">
            <h3>Visitor Details</h3>
            
            {/* NEW: Scrollable Area */}
            <div className="flyer-admin-modalScroll">
              <table className="flyer-admin-table">
                <thead>
                  <tr>
                    <th className="flyer-admin-th">Company</th>
                    <th className="flyer-admin-th">Member Mobile</th>
                    <th className="flyer-admin-th">Visited At</th>
                  </tr>
                </thead>
                <tbody>
                  {visits.map((v, i) => (
                    <tr key={i}>
                      <td className="flyer-admin-td">{v.member_company}</td>
                      <td className="flyer-admin-td">{v.member_mobile}</td>
                   <td className="flyer-admin-td">
{new Date(v.visited_at).toLocaleString("en-IN",{
  timeZone:"Asia/Kolkata",
  day:"2-digit",
  month:"short",
  year:"numeric",
  hour:"2-digit",
  minute:"2-digit",
  second:"2-digit"
})}
</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button
              className="flyer-admin-closeBtn"
              onClick={() => setSelected(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
